import { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from 'components/context/AuthContext';

const FacebookOAuthCallback = () => {
  const { loginWithToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Procesando autenticación con Facebook...');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const errorParam = queryParams.get('error_message') || queryParams.get('error');

    if (errorParam) {
      const msg = decodeURIComponent(errorParam);
      setStatus('error');
      setMessage(msg);
      setTimeout(() => navigate('/login', { state: { error: msg } }), 3000);
      return;
    }

    if (!token) {
      const msg = 'No se recibió el token de autenticación de Facebook.';
      setStatus('error');
      setMessage(msg);
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    loginWithToken(token)
      .then(() => {
        setStatus('success');
        setMessage('Sesión iniciada con éxito.');
        setTimeout(() => navigate('/home'), 1500);
      })
      .catch(() => {
        const msg = 'Error durante el login con Facebook.';
        setStatus('error');
        setMessage(msg);
        setTimeout(() => navigate('/login'), 3000);
      });
  }, [location, loginWithToken, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        {status === 'loading' && (
          <>
            <h2 className="text-xl font-bold text-gray-800">Procesando conexión con Facebook...</h2>
            <p className="mt-4 text-gray-600">Por favor, espera un momento.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <h2 className="text-xl font-bold text-green-600">Éxito</h2>
            <p className="mt-4 text-gray-700">{message}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 className="text-xl font-bold text-red-600">Error</h2>
            <p className="mt-4 text-gray-700">{message}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default FacebookOAuthCallback;
